import React, { Component } from "react";
import SideMenu from "../SideMenu/SideMenu";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import UserListContainer from "../UserList";
import MappedUserListContainer from "../UserMapping";
import { loggerEventOutcome, loggerEventTypes, loggerEventName } from '../../helpers/messages';
import { logger } from '../../services/logger/logger-service';
let startDate;
export default class UserTab extends Component {
	   constructor(props) {
       super(props);
       this.state = {
         currentTab: "usersList",
       };
     }

  componentDidMount() {
    // initialize the start date on page load
    startDate = new Date();
    window.addEventListener("beforeunload", this.applicationLogger);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.applicationLogger);
    this.applicationLogger();
  }

 /**
 * @description function to handle tab changes and log the event
 * @param {string} tabKey - The key of the tab that was selected
 * @memberof UserTab
 */
  handleTabChange = (tabKey) => {
    // Log the previous tab activity before switching
    this.applicationLogger(); 
	
	// Update the current tab
    this.setState({ currentTab: tabKey }); 
	
	// Reset start date for the new tab
    startDate = new Date();
  };
	
 /**
 * @description function to handle application logs
 * @param {*}
 * @memberof Settings
 */
  applicationLogger() {
    // calculate the time since we loaded this page
    const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
    const loggerObj = {
      EventOutcome: loggerEventOutcome.success,
      EventType: loggerEventTypes.read,
      EventName:
        this.state?.currentTab === "usersList"
          ? loggerEventName.userList
          : loggerEventName.snUserList,
      Content: {
        TimeSpent: timeSinceLoad,
      },
    };
    logger(loggerObj);
  }

	render() {
		return (
			<div className="bgGray">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-1">
							<SideMenu />
						</div>
						<div className="col-md-11">
							<div className="data-list-tabs planning-tool-wrap">
								<Tabs defaultActiveKey={"usersList"}   onSelect={this.handleTabChange}>
									<Tab eventKey="usersList" title="DAP Users">
										<UserListContainer />
									</Tab>
									<Tab eventKey="SNUsersList" title="S+N Users">
										<MappedUserListContainer />
									</Tab>
								</Tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
